import ContentContainer from "./ContentContainer";

export default ContentContainer;
